import { TestCard } from "@app/provider/testData/types";
import { IntlShape } from "react-intl";
import { messages } from "@app/provider/testData/messages";
import { ConnectTestCardBase } from "@app/provider/testData/testCard/connect/ConnectTestCardBase";

export class PanoramaTestCard extends ConnectTestCardBase {
  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (!testCard.sampleReceivedDate) {
      return intl.formatMessage(
        messages.testCardDefaultDescSampleReceivedPanorama
      );
    }
    return super.getDescriptionForSampleReceived(testCard, intl);
  }
}
